import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import theme from '@/constants/theme';
import styles from './styles';
import { Lock } from '@mui/icons-material';

export default function DailyIntro() {
  const navigate = useNavigate();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  const handleNext = () => {
    navigate('/records/daily-emotion');
  };

  return (
    <div style={styles.container}>
      <div style={styles.scrollContainer}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: windowHeight * 0.5,
            overflow: 'hidden',
          }}
        >
          <img
            src={require('@/assets/images/img-daily-intro.jpeg')}
            alt="Registro Diario"
            style={styles.img}
          />
          <div style={styles.linearGradient} />
        </div>

        <div
          style={{
            padding: '24px 16px',
            color: theme.colors.text.default,
          }}
        >
          <h1 style={styles.title}>Registro Diario</h1>
          <p style={styles.description}>
            El registro diario es una herramienta para tomar conciencia de tus emociones, pensamientos y
            experiencias a lo largo del día. Al escribir regularmente, puedes identificar patrones
            emocionales, comprender mejor tus reacciones y mejorar tu bienestar emocional. Además, recibirás
            consejos y técnicas útiles.
          </p>
          <div style={styles.privacyContainer}>
            <Lock />
            <div style={styles.privacyMessagesCotainer}>
              <h4 style={{ color: theme.colors.text.body }}>Tu privacidad es importante</h4>
              <p style={{ lineHeight: 1, color: theme.colors.text.caption }}>
                Toda lo que escribas o los consejos generados solo serán visibles para ti.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.buttonsContainer}>
        <button onClick={handleBack} style={styles.backButton}>
          <span style={styles.backButtonText}>Atrás</span>
        </button>
        <button onClick={handleNext} style={styles.nextButton}>
          <span style={styles.nextButtonText}>Comenzar</span>
        </button>
      </div>
    </div>
  );
}
